import { render } from "./ConfigManagement.vue?vue&type=template&id=0f9ad12c&scoped=true"
import script from "./ConfigManagement.vue?vue&type=script&lang=js"
export * from "./ConfigManagement.vue?vue&type=script&lang=js"

import "./ConfigManagement.vue?vue&type=style&index=0&id=0f9ad12c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f9ad12c"],['__file',"src/views/ProductManage/ConfigManagement/ConfigManagement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0f9ad12c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0f9ad12c', __exports__)) {
    api.reload('0f9ad12c', __exports__)
  }
  
  module.hot.accept("./ConfigManagement.vue?vue&type=template&id=0f9ad12c&scoped=true", () => {
    api.rerender('0f9ad12c', render)
  })

}


export default __exports__